import { IEligibilityApproveResponse } from './fetch-service';
import { redirect } from './parent-helper';

export interface IPaymentResponseHandler {
  response: IEligibilityApproveResponse;
  declinedCallback: () => void;
  approveCallback: () => void;
  challengeCallback: () => void;
}

export function paymentResponseHandler({
  response,
  approveCallback,
  declinedCallback,
  challengeCallback,
}: IPaymentResponseHandler): void {
  if (response?.parameters?.AutoRedirectUrl) {
    return redirect(response?.parameters?.AutoRedirectUrl, response?.parameters?.Redirect || '_self');
  }

  if (response?.parameters?.Redirect === 'Approve') {
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage(
      { message: 'demoMessage', value: '<span class="green">FlexFactor: transaction approved.</span>' },
      '*',
    );
  }
  if (response?.parameters?.Redirect === 'Decline') {
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage(
      { message: 'demoMessage', value: '<span class="green">FlexFactor: transaction declined.</span>' },
      '*',
    );
  }
  switch (response.result) {
    case 'NOT_ELIGIBLE':
    case 'DECLINED':
    case 'ORDER_DECLINED':
      declinedCallback();
      break;
    case 'ORDER_APPROVED':
      approveCallback();
      break;
    case 'CONDITIONAL_CONSUMER_INTERACTION':
    case 'PROCESSING':
    case 'WAITING_FOR_APPROVAL':
      challengeCallback();
      break;
    default:
      // TODO CHECK all possible cases
      // declinedCallback();
      challengeCallback();
  }
}
